import React, { useEffect, useRef, useState } from 'react';

import dayjs from 'dayjs';

import * as S from './styled';

import { getAllStats, getInfoStats } from '../../../hooks/indicators';
import { cardsChartNormalizer } from '../../../utils/normalizers/homeIndicators';
import { datesRangeType, IDateRangeModalRef } from '../../atoms/DateRangeModal';
import HomeIndicators from '../../organisms/HomeIndicators/HomeIndicators';
import HomeIndicatorsPortrait from '../../organisms/HomeIndicators/HomeIndicatorsPortrait';
import StationMapFilterable from '../../organisms/StationMapFilterable';

const START = dayjs()
  .subtract(7, 'day')
  .set('hour', 0)
  .set('minute', 0)
  .set('second', 0)
  .format('YYYY-MM-DD HH:mm:ss');
const END = dayjs()
  .set('hour', 23)
  .set('minute', 59)
  .set('second', 59)
  .format('YYYY-MM-DD HH:mm:ss');
const MIN_START = dayjs('2010-01-01 00:00').toDate();
const MAX_END = dayjs(END).toDate();

const Home = () => {
  const [energyLoading, setEnergyLoading] = useState(true);
  const [costLoading, setCostLoading] = useState(true);
  const [incomeLoading, setIncomeLoading] = useState(true);
  const [environLoading, setEnvironLoading] = useState(true);
  const [infoLoading, setInfoLoading] = useState(true);

  const dateRangeRef = useRef<IDateRangeModalRef>(null);

  const [datesRangeValue, setDatesRangeValue] = useState<datesRangeType>({
    start: START,
    end: END,
  });

  const [allStats, setAllStats] = useState<any>({});

  const openDateRange = () => {
    if (dateRangeRef.current) {
      dateRangeRef.current.open();
    }
  };

  const handleChangeDateRange = ({ start, end }: datesRangeType) => {
    setDatesRangeValue({ start, end });

    setEnergyLoading(true);
    setCostLoading(true);
    setIncomeLoading(true);
    setEnvironLoading(true);
    setInfoLoading(true);
  };

  useEffect(() => {
    (async function () {
      const { start, end } = datesRangeValue;

      let stats: any = {};

      getAllStats(start, end).then((response) => {
        stats = {
          ...stats,
          ...response,
        };

        setAllStats(cardsChartNormalizer(stats));

        setEnergyLoading(false);

        setEnvironLoading(false);

        setCostLoading(false);

        setIncomeLoading(false);
      });

      getInfoStats(start, end).then((info) => {
        stats = { ...stats, ...info };

        setAllStats(cardsChartNormalizer(stats));

        setInfoLoading(false);
      });
    })();
  }, [datesRangeValue]);

  return (
    <>
      <HomeIndicators
        allStats={allStats}
        openDateRange={openDateRange}
        datesRangeValue={datesRangeValue}
        dateRangeRef={dateRangeRef}
        START={START}
        END={END}
        handleChangeDateRange={handleChangeDateRange}
        MIN_START={MIN_START}
        MAX_END={MAX_END}
        environLoading={environLoading}
        infoLoading={infoLoading}
      />

      <S.SubWrapper>
        <S.MapWrapper>
          <StationMapFilterable />
        </S.MapWrapper>

        <HomeIndicatorsPortrait
          allStats={allStats}
          energyLoading={energyLoading}
          costLoading={costLoading}
          incomeLoading={incomeLoading}
        />
      </S.SubWrapper>
    </>
  );
};

export default Home;
